module.exports = "<p>\n  category: {{parentCategoryBreadcrumb}}\n</p>\n"


//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/containers/parent-category/parent-category.component.html
// module id = ../../../../../src/app/admin-area/containers/parent-category/parent-category.component.html
// module chunks = main